import { skipToken, useQuery } from "@tanstack/react-query";
import { getLeadsReferrer } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import type { AffiliateUserRole } from "Types/types";

export const affiliateCodeKeys = {
  all: ["AFFILIATE_CODE"] as const,
  referrer: (role: AffiliateUserRole) =>
    [...affiliateCodeKeys.all, "referrer", role] as const,
  verification: (role: AffiliateUserRole, code: string | null) =>
    [...affiliateCodeKeys.all, "verification", role, code] as const,
};

/** Who referred the caller for the role — the registration affiliate field locks on it. */
export const useAffiliateReferrerQuery = (
  role: AffiliateUserRole,
  { isEnabled = true }: { isEnabled?: boolean } = {},
) =>
  useQuery({
    queryKey: affiliateCodeKeys.referrer(role),
    queryFn: isEnabled
      ? processResponseWithApiProblemDetails(() => getLeadsReferrer(role))
      : skipToken,
    refetchOnWindowFocus: false,
  });
